import MessageEditor from "./MessageEditor.vue";
export default MessageEditor;
